const config = {
  siteName: "Flowly",
  siteTitle: "Flowly Inc", // Site title.
  siteTitleShort: "Flowly", // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: "Flowly", // Alternative site title for SEO.
  siteLogo: "src/assets/img/logo-512.png", // Logo used for SEO and manifest. Relative to /
  siteUrl: "https://getflowly.com", // Domain of your website without pathPrefix.
  siteDescription: "Flowly", // Website description used for RSS feeds/meta description tag.
  siteAuthor: "Flowly Inc", // Site author
  favIcon: "src/assets/img/favicon.ico",
  baseUrl: "https://getflowly.com",
  facebookUrl: "https://www.facebook.com/flowly",
  twitterUrl: "https://twitter.com/flowly",
  instagramUrl: "https://www.instagram.com/flowly",
  linkedinUrl: "https://www.linkedin.com/in/flowly",
  githubUrl: "https://github.com/flowly",
  primaryColor: "#3E78BC",
  primaryBoxShadow: "0 12px 20px -10px rgba(62, 120, 188, 0.2), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(62, 120, 188, 0.2)",
  primaryBoxShadowHover: "0 14px 26px -12px rgba(62, 120, 188, 0.6), 0 4px 23px 0px rgba(0, 0, 0, 0.24), 0 8px 10px -5px rgba(62, 120, 188, 0.4)"
};

module.exports = config;
